import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Topbar from "../../../components/Topbar/Topbar";

const BANNER_TABS = [
  { id: 1, name: "Home Banner", nav: "/home-banners" },
  { id: 2, name: "Property Banner", nav: "/property-banners" },
  { id: 3, name: "Refer & Earn Banner", nav: "/refer-and-earn" },
  { id: 4, name: "Booking Detail Banner", nav: "/booking-details" },
  { id: 5, name: "Wallet Banner", nav: "/wallet-banner" },
  { id: 6, name: "Day Outing Free Ticket Banner", nav: "/day-outing" },
  { id: 7, name: "Owner Banner", nav: "/owner-banner" },
  { id: 8, name: "Booking history banner", nav: "/booking-banner" },
];

const Banner = () => {
  const navigate = useNavigate();
  const [tabs, setTabs] = useState(1);

  return (
    <div>
      <Topbar header={"Banner"} />
      <div className="d-flex flex-wrap gap-3">
        {BANNER_TABS.map(({ id, name, nav }) => (
          <div
            key={id}
            onClick={() => {
              setTabs(id);
              navigate(nav, { state: { type: "add" } });
            }}
            className={`${tabs === id ? "Act-tabs" : "tabs"} d-flex ac-jc`}
          >
            {name}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Banner;
